import React, { useState, useEffect, useContext } from "react";
import NavButton from "../../components/NavButton/index";
import ContentHeader from "../../components/ContentHeader/index";
import LoaderAnim from "../../components/LoaderAnim/index";
import { useDataApi, API } from "../../components/API/index";
import MsmContext, { Actions } from "../../reducers/Context";
import useDebounce from "../../hooks/useDebounce";
import FormInput from "../../components/FormInputs/FormInput";

const TeamSearch = props => {
  const { dispatch, state } = useContext(MsmContext);

  const [searchFor, setSearchFor] = useState(state.teamSearchTerm || "");
  const debouncedSearchTerm = useDebounce(searchFor, 500);

  const { data, isLoading, isError, doFetch } = useDataApi("", {
    teams: []
  });

  useEffect(() => {
    if (debouncedSearchTerm && debouncedSearchTerm.length >= 3) {
      if (state.teamMemberMode) {
        doFetch(`${API.SEARCH_TEAMSTATS_TEAMS}?searchFor=${searchFor}`);
      } else {
        doFetch(`${API.SEARCH_FT_TEAMS}?searchFor=${searchFor}`);
      }
      dispatch({
        type: Actions.SEARCHED_FOR_TEAM_NAME,
        payload: { teamName: debouncedSearchTerm }
      });
    }
  }, [debouncedSearchTerm]);

  const didSelectTeam = team => {
    //console.log("selected", team);
    dispatch({
      type: Actions.SELECTED_TEAM,
      payload: { team }
    });
  };

  useEffect(() => {
    //console.log("got data", data);
  }, [data]);

  return (
    <>
      <ContentHeader
        text="What is your team called?"
        icon="whitesoccer"
        iconFill="teal"
        iconSize="25"
      />

      <div className="afs-msm-stage-content has-sticky-header">
        <div className="afs-msm-input-holder afs-msm-sticky add-all-padding">
          <FormInput
            type="text"
            label="Search for and select your team"
            value={searchFor}
            onChange={event => setSearchFor(event.target.value)}
            placeholder="Minimum 3 characters"
            helper={
              state.teamMemberMode
                ? ""
                : "Select your team to activate match and player import features. If you need to add more teams you can easily do this later."
            }
          />
        </div>
        {isError && <div>Something went wrong ...</div>}

        {isLoading ? (
          <LoaderAnim />
        ) : (
          <ul>
            {(data.teams && !data.teams.length) ||
              (data.faFullTimeTeams && !data.faFullTimeTeams.length && (
                <p className="add-all-padding">
                  No matching teams found - try again using your team name
                  exactly as it is shown on FA Full Time. If you don't use FA
                  Full Time then click the "team not listed" link below.
                </p>
              ))}

            {state.teamMemberMode
              ? data.teams &&
                data.teams.map(team => {
                  return (
                    <TSTeamResult
                      selected={() => {
                        didSelectTeam(team);
                      }}
                      key={team.TeamSiteTeamID}
                      {...team}
                    />
                  );
                })
              : data.faFullTimeTeams &&
                data.faFullTimeTeams.map(team => {
                  return (
                    <FTTeamResult
                      selected={() => {
                        didSelectTeam(team);
                      }}
                      key={team.FullTimeIntTeamID}
                      {...team}
                    />
                  );
                })}
          </ul>
        )}
      </div>
      <div className="afs-msm-stage-action-buttons">
        <NavButton text="BACK" actionType={Actions.PREV_STAGE} />
        {!state.teamMemberMode ? (
          <NavButton
            text="TEAM NOT LISTED?"
            actionType={Actions.SELECTED_TEAM_NOT_LISTED}
          />
        ) : null}
      </div>
    </>
  );
};

const TSTeamResult = props => {
  return (
    <li
      onClick={props.selected}
      className="afs-msm-team-search-result add-all-padding"
    >
      <b className="afs-msm-team-search-result-name">
        {props.TeamSiteDisplayName}
      </b>
      <div className="afs-msm-team-search-result-sub-text">
        {`Club Admin: ${props.ClubAdminUserFirstName} ${props.ClubAdminUserSurname}`}
      </div>
    </li>
  );
};

const FTTeamResult = props => {
  return (
    <li
      onClick={props.selected}
      className="afs-msm-team-search-result add-all-padding"
    >
      <b className="afs-msm-team-search-result-name">
        {props.FullTimeTeamName}
      </b>
      <div className="afs-msm-team-search-result-sub-text">
        {props.FullTimeLink}
      </div>
    </li>
  );
};

export default {
  id: "team-search",
  title: "Sign up to TeamStats",
  subtitles: [
    "Manage, analyse and organise your team and players. Professional features for all football teams."
  ],
  imageUrl:
    "https://assets.teamstats.net/img-m-600-70/backgrounds/football-background-2.jpg",
  component: TeamSearch
};
